import { useMemo } from 'react';
import { useAuth } from '../../../../../context/AuthContext';

export const useFilteredTask = (taskList) => {
  const { authUser } = useAuth();

  const filteredData = useMemo(() => {
    if (!taskList) {
      return { 
        toDos: [], reminders: [], leads: [], mine: [], 
        myAssigned: [], highPriority: [], medPriority: [], 
        lowPriority: [], todaysTask: [], dueToday: [], 
        startToday: [], recentUpdated: [] 
      };
    }

    // Get current date in YYYY-MM-DD format
    const now = new Date();
    const todayStr = now.toISOString().split('T')[0]; 
    // Note: .toISOString() uses UTC. If you need local time, 
    // use: now.toLocaleDateString('en-CA') (which results in YYYY-MM-DD)

    return {
      // Original Filters
      toDos: taskList.filter(task => task.calendarType === 1),
      reminders: taskList.filter(task => task.calendarType === 2),
      leads: taskList.filter(task => task.calendarType === 3),
      mine: taskList.filter(task => task.userId === authUser?.id),
      myAssigned: taskList.filter(task => task.assignedTo === authUser?.id),
      highPriority: taskList.filter(task => task.priority === 1),
      medPriority: taskList.filter(task => task.priority === 2),
      lowPriority: taskList.filter(task => task.priority === 3),

      // New Date Filters
      startToday: taskList.filter(task => task.startDate === todayStr),
      
      dueToday: taskList.filter(task => task.endDate === todayStr),

      overDue: taskList.filter(task => task.endDate < todayStr),
      
      todaysTask: taskList.filter(task => 
        task.startDate === todayStr || task.endDate === todayStr
      ),
      
      recentUpdated: taskList.filter(task => 
        task.updated_at && task.updated_at.startsWith(todayStr)
      ),
    };
  }, [taskList, authUser?.id]); // Added authUser?.id to dependencies for safety

  return filteredData;
};